<template>
  <div class="select-item flex flex-row gap-3 items-center w-full" :class="[{ collapsed: isCollapsedState }]">
    <div class="flex flex-col text-sm flex-grow justify-between" :class="{ 'overflow-hidden': overflow === 'ellipsis' }">
      <div
        :id="id && `${id}-label`"
        class="font-medium text-gray-900 max-w-72"
        :class="{ 'overflow-ellipsis overflow-hidden whitespace-nowrap': overflow === 'ellipsis' }"
        :style="{ minWidth: 0 }"
      >
        {{ item.title }}
      </div>
      <div :id="id && `${id}-description`" class="font-light text-gray-700" data-testid="last-updated">
        Updated {{ formatDateMed(item.updated_at) }}
      </div>
    </div>
    <AccessTypeIcon :access-type="item.base_access" />
  </div>
</template>

<script lang="ts" setup>
import type { Deck } from '@/entities/deck'
import { formatDateMed } from '@/lib/datetime-format-utils'
import AccessTypeIcon from '@/components/AccessTypeIcon.vue'

defineProps({
  item: {
    type: Object as PropType<Deck>,
    required: true,
  },
  id: {
    type: String,
    default: undefined,
  },
  isCollapsedState: {
    type: Boolean,
    required: true,
  },
  overflow: {
    type: String,
    default: 'visible',
  },
})
</script>

<style lang="stylus" scoped>
.corner-badge
  @apply py-1 px-3 rounded-full text-white text-xs float-right
  @apply top-4 right-4
</style>
